export class UpdateBillingDateRequestModel {

  constructor(private billingDate: string, private comment: string) {
  }

  public static create() {
    return new UpdateBillingDateRequestModel((new Date()).toLocaleString(), 'Billing date updated');
  }
}
